'use strict';

screenService.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.screenService = screenService;
/*@ngInject*/
function screenService($window) {

    var breakpointMobileMenu = 768;

    return {
        getNavigationMenuMode: getNavigationMenuMode
    };

    function getNavigationMenuMode() {
        return $window.innerWidth < breakpointMobileMenu ? 'mobile' : 'desktop';
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/screenService.js
// module id = 828
// module chunks = 0